import { render, staticRenderFns } from "./GTSustainability.vue?vue&type=template&id=0d40a3ce&scoped=true&"
import script from "./GTSustainability.vue?vue&type=script&lang=ts&"
export * from "./GTSustainability.vue?vue&type=script&lang=ts&"
import style0 from "./GTSustainability.vue?vue&type=style&index=0&id=0d40a3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d40a3ce",
  null
  
)

export default component.exports